import { CSSProperties } from 'react';
import '../utilities/utils.css';

const classes: { [key: string]: CSSProperties } = {};

interface Props {
    checked?: boolean;
    sx?: CSSProperties;
    setChecked?: (value: boolean) => void;
    disabled?: boolean;
    green?: boolean;
    pink?: boolean;
    white?: boolean;
}

export function CheckBox({ checked = false, sx, setChecked, disabled, green, pink, white }: Props): JSX.Element {
    const getClassName = () => {
        const classes = ['custom-checkbox'];
        if (green && checked) classes.push('checkbox-green');
        if (pink) classes.push('checkbox-pink');
        if (white) classes.push('checkbox-white');
        return classes.join(' ');
    };

    return (
        <input
            type="checkbox"
            className={getClassName()}
            checked={checked}
            disabled={disabled}
            onChange={(e) => {
                setChecked ? setChecked(e.target.checked) : () => {};
            }}
            style={{
                cursor: disabled ? 'not-allowed' : 'pointer',
                width: '24px',
                height: '24px',
                ...sx
            }}
        />
    );
}
